export const ACCOUNTANT_CONTENT = [
	{
		id: 1,
		title: 'Specjalistyczna księgowość dla transportu',
		text: 'Prowadzenie działalności transportowej wiąże się z wieloma wyzwaniami – zmieniające się przepisy, konieczność ewidencjonowania kosztów paliwa, rozliczania diet kierowców czy kontroli czasu pracy. W MAWEX znamy specyfikę branży transportowej i zapewniamy kompleksową obsługę księgową, dostosowaną do Twoich potrzeb.',
	},
	{
		id: 2,
		title: 'Oszczędność czasu i pieniędzy',
		text: 'Dzięki naszej wiedzy i doświadczeniu optymalizujemy procesy księgowe, pomagamy unikać błędów i niepotrzebnych kosztów. Powierzając nam księgowość, możesz skupić się na prowadzeniu biznesu, mając pewność, że Twoje finanse są w dobrych rękach.',
	},
	{
		id: 3,
		title: 'Pełna zgodność z przepisami',
		text: 'Branża transportowa podlega rygorystycznym regulacjom podatkowym i prawnym. Nasz zespół na bieżąco śledzi zmiany w przepisach, aby zapewnić Ci pełne bezpieczeństwo podatkowe i minimalizować ryzyko kontroli skarbowych.',
	},
	{
		id: 4,
		title: 'Indywidualne podejście i doradztwo',
		text: 'Każda firma transportowa jest inna, dlatego dopasowujemy nasze usługi do Twoich oczekiwań. Oferujemy nie tylko prowadzenie księgowości, ale także wsparcie w optymalizacji kosztów, doradztwo podatkowe i pomoc w rozwijaniu Twojej działalności.',
	},
	{
		id: 5,
		title: 'Nowoczesne rozwiązania',
		text: 'Współpracujemy z nowoczesnymi systemami księgowymi, które usprawniają wymianę dokumentów i raportowanie. Dzięki temu masz szybki dostęp do aktualnych danych finansowych swojej firmy.',
	},
	{
		id: 6,
		title: 'Zaufaj ekspertom od transportu',
		text: 'Nasza wiedza i doświadczenie w obsłudze firm transportowych sprawiają, że jesteśmy partnerem, na którym możesz polegać. Skontaktuj się z nami i dowiedz się, jak możemy pomóc Twojej firmie rozwijać się bez obciążeń księgowych.',
	},
];
